import { useEffect, useRef } from 'react';
import { useShallow } from 'zustand/react/shallow';

import { useFetchAccount } from '@/features/account/api/get-account';
import usePromocodeInfo from '@/features/referrals/api/get-promocode-info';
import useRewards from '@/features/referrals/api/get-rewards';
import { useCapitalStore } from '@/store/use-capital-store';

export default function DiscountGroupsHandler() {
  const { data: account, isFetched: isAccountFetched } = useFetchAccount();
  const { data: rewardsData } = useRewards();
  const { data: promocodeInfo, isFetched: isPromocodeInfoFetched } =
    usePromocodeInfo(account?.refCode ?? '');

  const hasValidatedDiscounts = useRef<boolean>(false);
  const hasAutoApplied = useRef<boolean>(false);

  const { discountGroups, appliedDiscountGroup } = useCapitalStore(
    useShallow((state) => ({
      discountGroups: state.discountGroups,
      appliedDiscountGroup: state.appliedDiscountGroup,
    })),
  );

  useEffect(() => {
    if (!isAccountFetched || !rewardsData) return;

    useCapitalStore
      .getState()
      .syncDiscountGroups(
        rewardsData.rewards,
        !rewardsData.signup_ref_discount && promocodeInfo
          ? [promocodeInfo]
          : [],
      );

    if (
      !account?.refCode ||
      rewardsData.signup_ref_discount ||
      isPromocodeInfoFetched
    ) {
      hasValidatedDiscounts.current = true;
    }
  }, [
    isAccountFetched,
    rewardsData,
    promocodeInfo,
    account?.refCode,
    isPromocodeInfoFetched,
  ]);

  useEffect(() => {
    if (
      !hasValidatedDiscounts.current ||
      hasAutoApplied.current ||
      discountGroups.length === 0
    ) {
      return;
    }

    if (appliedDiscountGroup) {
      hasAutoApplied.current = true;
      return;
    }

    if (discountGroups[0]) {
      useCapitalStore.getState().setAppliedDiscountGroup(discountGroups[0]);
      hasAutoApplied.current = true;
    }
  }, [discountGroups, appliedDiscountGroup]);

  return <></>;
}
